import {
  FormField,
  FormSubmitButton,
  FormWrapper,
} from "@/components/form/common";
import { Input, Textarea } from "@/components/form/fields";
import { createUserPermission } from "@/pages/admin/users/permissions/lib/actions";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const CreateUserPermissionForm = () => {
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm();
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const response = await createUserPermission(data, navigate);

      if (response.errors) {
        Object.keys(response.errors).forEach((field) =>
          setError(field, { type: "manual", message: response.errors[field] }),
        );
      }
    } catch {
      setError("root", { type: "manual", message: "An error occurred" });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormWrapper>
        <FormField name="name" label="Naam" formState={{ errors }}>
          <Controller
            name="name"
            control={control}
            rules={{ required: "Naam is required" }}
            render={({ field }) => <Input {...field} className="w-full" />}
          />
        </FormField>

        <FormField
          name="description"
          label="Omschrijving"
          formState={{ errors }}
        >
          <Controller
            name="description"
            control={control}
            rules={{ required: "Omschrijving is required" }}
            render={({ field }) => <Textarea {...field} className="w-full" />}
          />
        </FormField>

        <FormSubmitButton disabled={isSubmitting} isSubmitting={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Aanmaken"}
        </FormSubmitButton>
      </FormWrapper>
    </form>
  );
};
